module.exports = __webpack_public_path__ + "img/helpbox-2.8455e856.png";